/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Preview_Response_InvalidInputs */

const vi_einvoice_error_preview_response_invalid = /** @type {(inputs: Einvoice_Error_Preview_Response_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA trả về dữ liệu xem trước không hợp lệ. Vui lòng thử lại sau.`)
};

/**

* @param {Einvoice_Error_Preview_Response_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_preview_response_invalid = /** @type {((inputs?: Einvoice_Error_Preview_Response_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Preview_Response_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_preview_response_invalid(inputs)
});